const $ = require("jquery");
require("slick-carousel");

function fallbackCopy(text) {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "absolute";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand("copy"); } catch (e) {}
    document.body.removeChild(ta);
}

$(function () {
    // ---- Reviews carousel (prev/next arrows, 3 up) ----
    // Same config as event-booking/main.js - this is a shared, reusable block.
    const $slider = $(".mc__reviews-slider");
    if ($slider.length) {
        const $nav = $(".mc__reviews-nav");
        const prevLabel = $nav.data("prev-label") || "Previous";
        const nextLabel = $nav.data("next-label") || "Next";
        const arrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            dots: false,
            arrows: true,
            appendArrows: $nav.length ? $nav : $slider,
            prevArrow: '<button type="button" class="mc__reviews-arrow mc__reviews-arrow--prev" aria-label="' + prevLabel + '">' + arrowSvg + '</button>',
            nextArrow: '<button type="button" class="mc__reviews-arrow mc__reviews-arrow--next" aria-label="' + nextLabel + '">' + arrowSvg + '</button>',
            responsive: [
                { breakpoint: 1200, settings: { slidesToShow: 2 } },
                { breakpoint: 768, settings: { slidesToShow: 1 } }
            ]
        });
    }

    // ---- Copy-to-clipboard for Ask Simply starter prompts ----
    // Same logic as event-booking/main.js - this is a shared, reusable block;
    // duplicated here (not extracted to app.js) to match how the rest of the
    // site currently wires this per-page, pending the shared partial in
    // progress on a separate branch.
    $(document).on("click", ".js-copy-prompt", function () {
        const btn = this;
        const text = $(btn).closest(".mc__ask-prompt").find(".mc__ask-prompt-text").text().trim();
        if (!text) return;
        const $status = $("[data-copy-status]");
        const msg = $status.data("copy-msg") || "";

        const done = function () {
            btn.classList.add("is-copied");
            if ($status.length) {
                $status.text("");
                setTimeout(function () { $status.text(msg); }, 30);
            }
            clearTimeout(btn._copyTimer);
            btn._copyTimer = setTimeout(function () { btn.classList.remove("is-copied"); }, 1600);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(done).catch(function () { fallbackCopy(text); done(); });
        } else {
            fallbackCopy(text);
            done();
        }
    });
});
